module.exports = __webpack_public_path__ + "static/media/pragati pipeline without shadow.27e2138c.svg";